/**
 * @Description
 */

import { post, get } from '@/common/request/index';

/**
 * 发送验证码
 * https://yapi.lanhanba.com/project/176/interface/api/34077
 */
export function authSendCode(params) {
  return post('/v2/auth/send/code', { ...params }, true);
}

/**
 * 发送验证码
 * https://yapi.lanhanba.com/project/176/interface/api/34077
 */
export function authSendCodeV2(params) {
  return post('/v2/auth/send/codeV2', { ...params }, true);
}

/**
 * 退出登录
 * https://yapi.lanhanba.com/project/176/interface/api/34079
 */
export function logout(params) {
  return get('/v2/auth/logout', { ...params }, true);
}
